/**
 * Labstep
 *
 * @module components/Group/Card/Preview
 * @desc Card for showing a single group
 */

import GroupInitials from 'labstep-web/components/Group/Initials';
import {
  Action,
  UserGroupActionMenu,
} from 'labstep-web/components/UserGroup/Action/Menu';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { Icon } from 'labstep-web/core/Icon';
import { Size } from 'labstep-web/core/Initials/types';
import LinkButton from 'labstep-web/core/Link/Button';
import type React from 'react';
import styles from './styles.module.scss';
import type { IUserGroupCardPreviewProps } from './types';

export const UserGroupCardPreview: React.FC<
  IUserGroupCardPreviewProps
> = ({ userGroup }) => (
  <div className={styles.container}>
    <LinkButton
      route={{ to: 'group_show', params: { id: userGroup.group.id } }}
    >
      <div className={styles.info}>
        <GroupInitials size={Size.tiny} group={userGroup.group} />
        <div className={styles.name}>
          <Header isDataPublic={false} size={Size.tiny}>
            {' '}
            {userGroup.group.name}
          </Header>
        </div>
      </div>
    </LinkButton>
    <Flex>
      {userGroup.is_home && (
        <Icon name="home" popup={{ content: 'Home Workspace' }} />
      )}
      <UserGroupActionMenu
        userGroup={userGroup}
        actions={[
          Action.leave,
          Action.view,
          Action.set_home,
          Action.delete_group,
        ]}
      />
    </Flex>
  </div>
);
